import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';
import { InventoryAuditUpdateInventoryBasedOnCountRequest } from "../models/inventory-audits";
import { InventoryAuditUpdateInventoryBasedOnCountResponse } from '../models/inventory-audits/inventory-audit-update-inventory-based-on-count-response';

@Injectable({
  providedIn: 'root'
})
export class InventoryAuditDataService {

  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public deleteSalesOrderLineAsync(id: number, timeout: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('InventoryAudits/DeleteInventoryProduct', id, timeout);
  }

  public updateInventoryBasedOnCountAsync(items: InventoryAuditUpdateInventoryBasedOnCountRequest[], timeout: Promise<any>): Promise<InventoryAuditUpdateInventoryBasedOnCountResponse> {
    return this.httpClient.postJsonAsync('InventoryAudits/UpdateInventoryBasedOnCount', items, timeout);
  }
}
